module.exports = function (data) {

    const padZero = (value) => {
        return ('00' + value).substr(-2);
    };
    const weekdayArr = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
    ];
    const isAsap = data.DeliveryType === 'ASAP';
    const date = isAsap ? new Date() : new Date(data.WindowDate);
    const deliveryDate = isAsap
        ? date.getFullYear() + '-' + padZero(date.getMonth() + 1) + '-' + padZero(date.getDate())
        : data.WindowDate;

    const deliveryTime = isAsap
        ? ''
        : data.WindowTime;

    const deliveryDay = weekdayArr[date.getDay()];

    const eventDate = new Date();

    return {
        event: data.event,
        eventContext: {
            area: data.area,
            deliveryType: data.DeliveryType,
            deliveryDate,
            deliveryTime,
            deliveryDay,
            orderNo: data.orderNo || '',
            eventTime: eventDate.getFullYear() + '-' + padZero(eventDate.getMonth() + 1) + '-' + padZero(eventDate.getDate()) + ' ' + eventDate.toTimeString()
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/atmmapper/delivery-timetable-analytics-mapper.js
 **/